import { render, staticRenderFns } from "./MortgagePage.vue?vue&type=template&id=46f72c58&scoped=true"
import script from "./MortgagePage.vue?vue&type=script&lang=js"
export * from "./MortgagePage.vue?vue&type=script&lang=js"
import style0 from "./MortgagePage.vue?vue&type=style&index=0&id=46f72c58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f72c58",
  null
  
)

export default component.exports